import LoaderImage from "@assets/cryptoloader.json";
import { Player } from "@lottiefiles/react-lottie-player";

const Loader = () => {
  return (
    <div className="max-w-screen-xl mx-autoxw flex items-center justify-center ">
      {/* <Lottie style={{ height: 300, width: 300 }} animationData={Loader} /> */}
      <Player
        loop
        src={LoaderImage}
        autoplay
        speed={4}
        style={{ height: 300, width: 300 }}
      />
    </div>
  );
};

export const MiniLoader = () => {
  return (
    <div className="h-full w-full flex items-center justify-center">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="lucide lucide-loader-circle animate-spin dark:text-white"
      >
        <path d="M21 12a9 9 0 1 1-6.219-8.56" />
      </svg>
    </div>
  );
};

export default Loader;
